var _path, _path2, _path3, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAchievementStarTournamentNonActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    filter: "url(#filter0_f_24_2381)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 1.35057L5.79502 3.79741L5.81935 3.87227H5.89806H8.47081L6.38941 5.38449L6.32573 5.43076L6.35005 5.50561L7.14508 7.95245L5.06368 6.44022L5 6.39396L4.93632 6.44022L2.85492 7.95245L3.64995 5.50561L3.67427 5.43076L3.61059 5.38449L1.52919 3.87227H4.10194H4.18065L4.20498 3.79741L5 1.35057Z",
    stroke: "#40FCF2",
    strokeWidth: 0.216667
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    filter: "url(#filter1_f_24_2381)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 1.45844L5.76332 3.80771L5.79513 3.9056H5.89806H8.36822L6.36982 5.35753L6.28655 5.41802L6.31835 5.51591L7.08167 7.86518L5.08327 6.41325L5 6.35275L4.91673 6.41325L2.91832 7.86518L3.68165 5.51591L3.71345 5.41802L3.63018 5.35753L1.63178 3.9056H4.10194H4.20487L4.23668 3.80771L5 1.45844Z",
    stroke: "#40FCF2",
    strokeWidth: 0.283333
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    filter: "url(#filter2_ddi_24_2381)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 1.35057L5.79502 3.79741L5.81935 3.87227H5.89806H8.47081L6.38941 5.38449L6.32573 5.43076L6.35005 5.50561L7.14508 7.95245L5.06368 6.44022L5 6.39396L4.93632 6.44022L2.85492 7.95245L3.64995 5.50561L3.67427 5.43076L3.61059 5.38449L1.52919 3.87227H4.10194H4.18065L4.20498 3.79741L5 1.35057Z",
    stroke: "#40FCF2",
    strokeOpacity: 0.2,
    strokeWidth: 0.216667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_24_2381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 1.21574L5.83465 3.78453L5.84962 3.8306H5.89806H8.59905L6.4139 5.4182L6.37471 5.44667L6.38968 5.49274L7.22433 8.06153L5.03919 6.47393L5 6.44546L4.96081 6.47393L2.77567 8.06153L3.61032 5.49274L3.62529 5.44667L3.5861 5.4182L1.40095 3.8306H4.10194H4.15038L4.16535 3.78453L5 1.21574Z",
    stroke: "#40FCF2",
    strokeWidth: 0.133333
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_24_2381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 1.10787L5.86635 3.77423L5.87384 3.79727H5.89806H8.70164L6.43349 5.44517L6.4139 5.4594L6.42138 5.48244L7.28774 8.1488L5.01959 6.5009L5 6.48666L4.98041 6.5009L2.71226 8.1488L3.57862 5.48244L3.5861 5.4594L3.56651 5.44517L1.29836 3.79727H4.10194H4.12616L4.13365 3.77423L5 1.10787Z",
    stroke: "white",
    strokeWidth: 0.0666667
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_24_2381",
    x: 0.195801,
    y: 0,
    width: 9.6084,
    height: 9.23605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_24_2381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_24_2381",
    x: 0.862467,
    y: 0.666667,
    width: 8.27507,
    height: 7.90272,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.166667,
    result: "effect1_foregroundBlur_24_2381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ddi_24_2381",
    x: 0.762467,
    y: 0.9,
    width: 8.47507,
    height: 8.10272,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.216667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0833333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.25098 0 0 0 0 0.988235 0 0 0 0 0.94902 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_2381"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.333333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.216667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.25098 0 0 0 0 0.988235 0 0 0 0 0.94902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "color-dodge",
    in2: "effect1_dropShadow_24_2381",
    result: "effect2_dropShadow_24_2381"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_24_2381",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.0216667,
    dy: 0.0433333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0108333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_24_2381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_24_2381",
    x: 1.16247,
    y: 0.966667,
    width: 7.67507,
    height: 7.30272,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0166667,
    result: "effect1_foregroundBlur_24_2381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_24_2381",
    x: 1.17358,
    y: 0.977778,
    width: 7.65284,
    height: 7.2805,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0111111,
    result: "effect1_foregroundBlur_24_2381"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievementStarTournamentNonActive);
export default __webpack_public_path__ + "static/media/achievement-star-tournament-non-active.456aa8cf63ca89ef8013cac0535dea39.svg";
export { ForwardRef as ReactComponent };